import classnames from 'classnames'

export default function Tabs({ tabs, activeIndex, onChange }) {
  return (
    <div className='tabs inlineFlex'>
      {tabs.map(({ tab, count }, i) => (
        <button
          key={`${tab}`}
          className={classnames('tab flex justifyCenter alignCenter', {
            active: activeIndex === i,
          })}
          onClick={() => onChange(i, activeIndex)}
        >
          {tab} {!!count && <span className='count flex justifyCenter alignCenter'>{count}</span>}
        </button>
      ))}

      <style jsx>{`
        .tabs {
          position: relative;
          overflow: hidden;
          height: 5rem;
          width: 100%;
          border-radius: 2.5rem;
          background: #1a1e21;
          z-index: 1;

          &::before {
            content: '';
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            height: 100%;
            background: var(--primary-color);
            border-radius: 2.5rem;
            transition: transform 0.3s;
          }

          .tab {
            position: relative;
            z-index: 10;
            height: 100%;
            border-radius: inherit;
            background: transparent;
            outline: none;
            color: var(--primary-text-color);
            transition: color 0.4s;
            white-space: nowrap;
            font-size: 2.2rem;

            &:focus {
              color: var(--primary-color);
              box-shadow: inset 0 0 0 0.2rem var(--primary-color);
            }

            &.active {
              color: #fff;
              font-weight: 700;
            }

            .count {
              display: inline-block;
              width: 2rem;
              height: 2rem;
              margin: 0 0 0 0.7rem;
              color: #fff;
              background: var(--alert-color);
              border-radius: 50%;
              line-height: 2rem;
              font-size: 1.2rem;
            }
          }
        }

        @media (max-width: 1364px) {
          .tabs {
            height: 3.5rem;

            .tab {
              font-size: 1.2rem;
            }
          }
        }

        @media (max-width: 1024px) {
          .tabs > .tab > .count {
            width: 1.2rem;
            height: 1.2rem;
            margin: 0 0 0 0.3rem;
            line-height: 1.2rem;
            font-size: 0.8rem;
          }
        }
      `}</style>

      <style jsx>{`
        .tabs {
          .tab {
            width: calc(100% / ${tabs.length});
          }

          &::before {
            width: calc(100% / ${tabs.length});
            transform: translateX(calc(100% * ${activeIndex}));
          }
        }
      `}</style>
    </div>
  )
}
